const theme = {
  //primary-colors
  PRIMARY_CLASSIC_BLUE: "#263746",
  PRIMARY_ELECTRIC_BLUE: "#0678D5",
  PRIMARY_ARCTIC_GRAY: "#E3E3E3",
  PRIMARY_PURE_WHITE: "#FFFFFF",
  //secondary-colors
  SECONDARY_EGGSHELL_WHITE: "#EEF0E2",
  SECONDARY_CHEERFUL_GOLD: "#F3B921",
  SECONDARY_HOPEFUL_GREEN: "#3EBD3E",
  SECONDARY_SHOCKING_BLUE: "#00AEEF",
  SECONDARY_ROYAL_BLUE: "#1818B5",
  SECONDARY_PASSION_RED: "#AC1534",
  SECONDARY_CHARCOAL_GRAY: "#757584",
  SECONDARY_CLASSIC_LIGHT: "#385263",
  SECONDARY_CLASSIC_DARK: "#18252D",
  SECONDARY_NEARLY_BLACK: "#000921",
  PRIMARY_RED:"#f93e3e",
  PRIMARY_LIGHT_GREEN:"#49cc90"

};

export default theme;
